$(document).ready(function () {
    if (!$('.cv-creator__form').length && !$('.cv-creator__content').length) {
        return;
    }

    var base_url = $('#base_url').val();
    var template_directory = $('#template_directory').val();

    // Initialize Materialize Components for Navbar
    // Dropdown menus
    $('.dropdown-trigger').dropdown({
        hover: true,
        coverTrigger: false,
        constrainWidth: false
    });

    // Mobile Sidenav
    $('.sidenav').sidenav({
        edge: 'right',
        draggable: true
    });

    // Collapsible menus in sidenav
    $('.collapsible').collapsible();

    // Initialize Materialize Tooltips
    var tooltipElems = document.querySelectorAll('.tooltipped');
    M.Tooltip.init(tooltipElems, {
        position: 'top',
        enterDelay: 200,
        exitDelay: 0,
        margin: 5,
        inDuration: 300,
        outDuration: 250,
        transitionMovement: 10
    });

    function setupToggle(iconId, inputId) {
        $('#' + iconId).off('click').on('click', function () {
            const $input = $('#' + inputId);
            const isPasswordVisible = $input.attr('type') === 'text';
            $input.attr('type', isPasswordVisible ? 'password' : 'text');
            $(this).text(isPasswordVisible ? 'visibility_off' : 'visibility');
        });
    }

    
    setupToggle('togglePassword', 'password');
    setupToggle('toggleConfirmPassword', 'confirm_password');    

    $('#global-loader').hide();

    function cvcreatorSetPortfolioUrlErrorState(num, isInvalid) {
        var $input = $('#url_' + num);
        if (!$input.length) {
            return;
        }
        var $wrap = $input.closest('.input-field');
        var $err = $wrap.find('.portfolio-url-error');
        if (!$err.length) {
            $err = $('<span class="portfolio-url-error" role="alert"></span>');
            $wrap.append($err);
        }
        if (isInvalid) {
            $input.addClass('invalid');
            $input.attr('aria-invalid', 'true');
            $err.html('Usa una URL con <strong>dominio completo</strong> (ej. <strong>https://gitlab.com/usuario</strong> — con extensión .com, .mx, etc.).');
        } else {
            $input.removeClass('invalid');
            $input.removeAttr('aria-invalid');
            $err.empty();
        }
    }

    function cvcreatorSetPortfolioPlatformErrorState(num, isInvalid) {
        var $sel = $('#platform_' + num);
        if (!$sel.length) {
            return;
        }
        var $wrap = $sel.closest('.input-field');
        var $err = $wrap.find('.portfolio-platform-error');
        if (!$err.length) {
            $err = $('<span class="portfolio-platform-error" role="alert"></span>');
            $wrap.append($err);
        }
        if (isInvalid) {
            $sel.addClass('invalid');
            $sel.attr('aria-invalid', 'true');
            $err.html('Selecciona una <strong>plataforma o tecnología</strong> en la lista.');
        } else {
            $sel.removeClass('invalid');
            $sel.removeAttr('aria-invalid');
            $err.empty();
        }
    }

    function cvcreatorSyncPortfolioLinkPair(num) {
        var rawUrl = String($('#url_' + num).val() || '').trim();
        var platRaw = $('#platform_' + num).val();
        var plat = platRaw === null || platRaw === undefined ? '' : String(platRaw).trim();
        var needsPlatform = rawUrl !== '' && plat === '';
        cvcreatorSetPortfolioPlatformErrorState(num, needsPlatform);
        var badUrl = !cvcreatorIsValidPortfolioUrl(rawUrl);
        cvcreatorSetPortfolioUrlErrorState(num, badUrl && rawUrl !== '');
    }

    function cvcreatorSyncPortfolioUrlFieldFromInput($field) {
        var id = ($field.attr('id') || '');
        var m = /^url_(\d+)$/.exec(id);
        if (!m) {
            return;
        }
        cvcreatorSyncPortfolioLinkPair(parseInt(m[1], 10));
    }

    function cvcreatorNormalizePortfolioUrlFieldFromInput($field) {
        var id = ($field.attr('id') || '');
        var m = /^url_(\d+)$/.exec(id);
        if (!m) {
            return;
        }
        var normalized = cvcreatorNormalizeUrlValue($field.val());
        if (($field.val() || '').trim() !== normalized) {
            $field.val(normalized);
        }
    }

    $(document).on('input', 'input[id^="url_"]', function () {
        cvcreatorSyncPortfolioUrlFieldFromInput($(this));
    });
    $(document).on('paste cut', 'input[id^="url_"]', function () {
        var $field = $(this);
        setTimeout(function () {
            cvcreatorSyncPortfolioUrlFieldFromInput($field);
        }, 0);
    });
    $(document).on('blur', 'input[id^="url_"]', function () {
        var $field = $(this);
        cvcreatorNormalizePortfolioUrlFieldFromInput($field);
        cvcreatorSyncPortfolioUrlFieldFromInput($field);
    });
    $(document).on('change', 'select[id^="platform_"]', function () {
        var sid = ($(this).attr('id') || '');
        var pm = /^platform_(\d+)$/.exec(sid);
        if (!pm) {
            return;
        }
        cvcreatorSyncPortfolioLinkPair(parseInt(pm[1], 10));
    });
    $(document).on('blur', '#linkedin_url', function () {
        var normalized = cvcreatorNormalizeUrlValue($(this).val());
        if (($(this).val() || '').trim() !== normalized) {
            $(this).val(normalized);
        }
    });

    /* Ultimo valor valido por ranura de enlace; si el URL actual es invalido, el PDF usa este snapshot y el resto del formulario sigue actualizando. */
    var portfolioPdfLastSent = {};

    function cvcreatorInitPortfolioPdfLastSentFromDom() {
        var ip;
        portfolioPdfLastSent = {};
        for (ip = 1; ip <= 10; ip++) {
            if (!$('#url_' + ip).length) {
                continue;
            }
            var $urlInput = $('#url_' + ip);
            var u = cvcreatorNormalizeUrlValue($urlInput.val());
            if (($urlInput.val() || '').trim() !== u) {
                $urlInput.val(u);
            }
            var plat = ($('#platform_' + ip).val() || '').trim();
            var plid = ($('#portfolio_links_id_' + ip).val() || '').trim();
            if (cvcreatorIsValidPortfolioUrl(u) && plat !== '') {
                portfolioPdfLastSent[ip] = {
                    url: u,
                    platform: plat,
                    portfolio_links_id: plid
                };
            } else if (u === '') {
                portfolioPdfLastSent[ip] = {
                    url: '',
                    platform: plat,
                    portfolio_links_id: plid
                };
            }
        }
    }

    function cvcreatorApplyPortfolioFieldsForPdf(fields) {
        var ip;
        for (ip = 1; ip <= 10; ip++) {
            if (!$('#url_' + ip).length) {
                continue;
            }
            var pidKey = 'portfolio_links_id_' + ip;
            var platKey = 'platform_' + ip;
            var urlKey = 'url_' + ip;
            var $urlInput = $('#url_' + ip);
            var u = cvcreatorNormalizeUrlValue($urlInput.val());
            if (($urlInput.val() || '').trim() !== u) {
                $urlInput.val(u);
            }
            var plat = ($('#platform_' + ip).val() || '').trim();
            var plid = ($('#portfolio_links_id_' + ip).val() || '').trim();
            if (u === '') {
                fields[pidKey] = plid;
                fields[platKey] = plat;
                fields[urlKey] = '';
                portfolioPdfLastSent[ip] = {
                    url: '',
                    platform: plat,
                    portfolio_links_id: plid
                };
            } else if (plat === '') {
                var snapPl = portfolioPdfLastSent[ip];
                if (snapPl) {
                    fields[pidKey] = snapPl.portfolio_links_id;
                    fields[platKey] = snapPl.platform;
                    fields[urlKey] = snapPl.url;
                } else {
                    fields[pidKey] = plid;
                    fields[platKey] = '';
                    fields[urlKey] = '';
                }
            } else if (cvcreatorIsValidPortfolioUrl(u)) {
                fields[pidKey] = plid;
                fields[platKey] = plat;
                fields[urlKey] = u;
                portfolioPdfLastSent[ip] = {
                    url: u,
                    platform: plat,
                    portfolio_links_id: plid
                };
            } else {
                var snap = portfolioPdfLastSent[ip];
                if (snap) {
                    fields[pidKey] = snap.portfolio_links_id;
                    fields[platKey] = snap.platform;
                    fields[urlKey] = snap.url;
                } else {
                    fields[pidKey] = plid;
                    fields[platKey] = plat;
                    fields[urlKey] = '';
                }
            }
        }
    }

    // CV Content 
    if ($('.cv-creator__content').length) {
        
        //Step 1 CTA Click
        $('.step_1 .cta button').on('click', function(e) {
            e.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, 800); 
            $('.step_1').fadeOut(0);
            $('.step_2').fadeIn('slow');

            return false;
        });

        //Step 2 Back Button Click
        $('.step_2 .nav .back-button').on('click', function(e) {
            e.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, 800);
            $('.step_2').fadeOut(0);
            $('.step_1').fadeIn('slow');

            return false;
        });

        //Step 2 CTA Click
        $('.step_2 .options .option .new').on('click', function(e) {
            e.preventDefault();

            var param = {
                "site": "talento",
                "msg": "initCV"
            };

            var fd = new FormData();
            fd.append('param', JSON.stringify(param));

            //Request API
            $.ajax({
                url: base_url + '/api',
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                success: function (response) {
                    window.location.href = base_url + '/crear-cv/?type=edit&language=es&pdf_id=' + response.data.id;
                }
            });

            return false;
        });
    }

    // CV Content (FREE version form)
    if ($('.cv-creator__form').length) {
        cvcreatorInitPortfolioPdfLastSentFromDom();
        (function () {
            var i;
            for (i = 1; i <= 10; i++) {
                if ($('#url_' + i).length) {
                    cvcreatorSyncPortfolioLinkPair(i);
                }
            }
        })();
        // Init Modal - CV Creator Download (FREE version)
        $('#modalForm').modal({
            dismissible: true,
            preventScrolling: true
        });

        loadPDFMiniViewers(base_url, function () {
            PDFMiniViewers.initialize(
                base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/pdf-worker.js',
                base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/cmaps'
            );
            fitPDFInViewer();
        });
        Simditor.locale = 'en-US';
        
        const saveButton = document.getElementById("saveButton");
        const overlay = document.getElementById("savingOverlay");

        /*
        Paths can be relative or absolute but should be on the same server:
        path/to/pdf-worker.js ==> Tell PMV where pdf-worker.js is located
        path/to/cmaps         ==> Tell PMV where the CMAP folder is located.
        */
        function loadPDFMiniViewers(baseUrl, callback) {
            const css = document.createElement('link');
            css.rel = 'stylesheet';
            css.href = baseUrl + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/css/main.css';
            document.head.appendChild(css);

            const script1 = document.createElement('script');
            script1.src = baseUrl + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/pdf.js';
            script1.onload = function () {
                const script2 = document.createElement('script');
                script2.src = baseUrl + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/pdf-viewer.js';
                script2.onload = callback;
                document.body.appendChild(script2);
            };
            document.body.appendChild(script1);
        }

        /**
         * Escala el PDF para que la hoja llene el panel preview (fit-to-page).
         * pdf-viewer.js aplica fit-by-width pero la hoja puede quedar cortada verticalmente.
         * Esta función aplica un CSS transform adicional para que la página completa sea visible.
         */
        function fitPDFInViewer() {
            var maxAttempts = 40;
            var attempt = 0;
            var timer = setInterval(function () {
                attempt++;
                var viewer = document.querySelector('.pdf-viewer');
                var page = viewer ? viewer.querySelector('.page') : null;
                if (!page || !page.offsetHeight || !viewer.clientHeight || !viewer.clientWidth) {
                    if (attempt >= maxAttempts) clearInterval(timer);
                    return;
                }
                clearInterval(timer);

                var viewerH = viewer.clientHeight - 30; // margen visual 15px arriba/abajo
                var viewerW = viewer.clientWidth - 30;  // margen visual 15px izq/der
                var pageH   = page.offsetHeight;
                var pageW   = page.offsetWidth;
                if (pageH <= 0 || pageW <= 0 || viewerH <= 0 || viewerW <= 0) return;

                var scaleH = viewerH / pageH;
                var scaleW = viewerW / pageW;
                // Usar el factor más restrictivo para que la hoja quepa sin recorte
                var scale  = Math.min(scaleH, scaleW);
                if (scale >= 1.0) return; // ya cabe sin reducir

                document.querySelectorAll('.pdf-viewer .page').forEach(function (p) {
                    var h = p.offsetHeight;
                    p.style.transform       = 'scale(' + scale.toFixed(3) + ')';
                    p.style.transformOrigin = 'top center';
                    // Colapsar el espacio vacío que deja el transform (no afecta layout)
                    p.style.marginTop    = '15px';
                    p.style.marginBottom = Math.floor(h * (scale - 1) - 15) + 'px';
                });
                // Ocultar scroll ya que la hoja cabe completa
                viewer.style.overflowX = 'hidden';
                viewer.style.overflowY = 'hidden';
            }, 200);
        }
        
        
        const input = document.querySelector("#mobile");
    
        const iti = intlTelInput.getInstance(input);

        if (!iti) {
        window.intlTelInput(input, {
            countryOrder: ["mx","us"],
            initialCountry: "mx",
            hiddenInput: () => ({ phone: "full_phone", country: "country_code" }),
            strictMode: true,
            i18n: {
                // Aria label for the selected country element
                selectedCountryAriaLabel: "País seleccionado",
                // Screen reader text for when no country is selected
                noCountrySelected: "No se ha seleccionado país",
                // Aria label for the country list element
                countryListAriaLabel: "Lista de países",
                // Placeholder for the search input in the dropdown
                searchPlaceholder: "Buscar",
                // Screen reader text for when the search produces no results
                zeroSearchResults: "No se encontraron resultados",
                // Screen reader text for when the search produces 1 result
                oneSearchResult: "1 resultado encontrado",
                // Screen reader text for when the search produces multiple results, where ${count} will be replaced by the count
                multipleSearchResults: "${count} resultados encontrados",
            },
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.1.0/build/js/utils.js",
        });
        }


        const wrappers = document.querySelectorAll(".iti");
if (wrappers.length > 1) {
  console.warn(`Se detectaron ${wrappers.length} instancias de flags, limpiando extras...`);
  wrappers.forEach((wrapper, index) => {
    if (index > 0) wrapper.remove();
  });
}


        
        /** RESUME EDITOR **/
        var resume_editor = new Simditor({
            textarea: $('#professional_summary'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        resume_editor.on('valuechanged', function(e, src) {
            var resume = resume_editor.getValue();
            var counter = resume.length;
            $('.resume_counter').text(counter + '/330');
            if (counter > 330) {
                $('.resume_counter').css('color', 'red');
            } else {
                $('.resume_counter').css('color', 'black');
            }
        });

        resume_editor.on('blur', function(e, src) {
            processPDF('professional_summary');
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 1 **/
        var description_1_editor = new Simditor({
            textarea: $('#description_1'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_1_editor.on('valuechanged', function(e, src) {
            var description = description_1_editor.getValue();
            var description_counter = description.length;
            $('.description_1_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_1_counter').css('color', 'red');
            } else {
                $('.description_1_counter').css('color', 'black');
            }
        });

        description_1_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_1 = $('#end_date_month_1').val();
            end_date_year_1 = $('#end_date_year_1').val();
            if (end_date_month_1 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_1 != '') { end_date = true; }
            }

            if (
                $('#occupation_title_1').val() != '' &&
                $('#company_1').val() != '' &&
                $('#start_date_month_1').val() != null &&
                $('#start_date_year_1').val() != null &&
                $('#end_date_month_1').val() != null &&
                end_date &&
                description_1_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 2 **/
        var description_2_editor = new Simditor({
            textarea: $('#description_2'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_2_editor.on('valuechanged', function(e, src) {
            var description = description_2_editor.getValue();
            var description_counter = description.length;
            $('.description_2_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_2_counter').css('color', 'red');
            } else {
                $('.description_2_counter').css('color', 'black');
            }
        });

        description_2_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_2 = $('#end_date_month_2').val();
            end_date_year_2 = $('#end_date_year_2').val();
            if (end_date_month_2 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_2 != '') { end_date = true; }
            }

            if (
                $('#occupation_title_2').val() != '' &&
                $('#company_2').val() != '' &&
                $('#start_date_month_2').val() != null &&
                $('#start_date_year_2').val() != null &&
                $('#end_date_month_2').val() != null &&
                end_date &&
                description_2_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 3 **/
        var description_3_editor = new Simditor({
            textarea: $('#description_3'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_3_editor.on('valuechanged', function(e, src) {
            var description = description_3_editor.getValue();
            var description_counter = description.length;
            $('.description_3_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_3_counter').css('color', 'red');
            } else {
                $('.description_3_counter').css('color', 'black');
            }
        });

        description_3_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_2 = $('#end_date_month_2').val();
            end_date_year_2 = $('#end_date_year_2').val();
            if (end_date_month_2 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_2 != '') { end_date = true; }
            }
            
            if (
                $('#occupation_title_3').val() != '' &&
                $('#company_3').val() != '' &&
                $('#start_date_month_3').val() != null &&
                $('#start_date_year_3').val() != null &&
                $('#end_date_month_3').val() != null &&
                end_date &&
                description_3_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 4 **/
        var description_4_editor = new Simditor({
            textarea: $('#description_4'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_4_editor.on('valuechanged', function(e, src) {
            var description = description_4_editor.getValue();
            var description_counter = description.length;
            $('.description_4_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_4_counter').css('color', 'red');
            } else {
                $('.description_4_counter').css('color', 'black');
            }
        });

        description_4_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_4 = $('#end_date_month_4').val();
            end_date_year_4 = $('#end_date_year_4').val();
            if (end_date_month_4 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_4 != '') { end_date = true; }
            }
            
            if (
                $('#occupation_title_4').val() != '' &&
                $('#company_4').val() != '' &&
                $('#start_date_month_4').val() != null &&
                $('#start_date_year_4').val() != null &&
                $('#end_date_month_4').val() != null &&
                end_date &&
                description_4_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 5 **/
        var description_5_editor = new Simditor({
            textarea: $('#description_5'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_5_editor.on('valuechanged', function(e, src) {
            var description = description_5_editor.getValue();
            var description_counter = description.length;
            $('.description_5_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_5_counter').css('color', 'red');
            } else {
                $('.description_5_counter').css('color', 'black');
            }
        });

        description_5_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_5 = $('#end_date_month_5').val();
            end_date_year_5 = $('#end_date_year_5').val();
            if (end_date_month_5 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_5 != '') { end_date = true; }
            }
            
            if (
                $('#occupation_title_5').val() != '' &&
                $('#company_5').val() != '' &&
                $('#start_date_month_5').val() != null &&
                $('#start_date_year_5').val() != null &&
                $('#end_date_month_5').val() != null &&
                end_date &&
                description_5_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        var type = $('#type').val();

        // Click Back
        $('.cv-creator__cv-form').on('click', '.back', function(e) {
            e.preventDefault();

            var redirect = $(this).attr('redirect');

            overlay.classList.add("active");

            var pdf_id = $('#pdf_id').val();
            var param = {
                "site": "talento", "msg": "saveCVCandidate",
            };
            var fields = {};
            fields['pdf_id'] = $('#pdf_id').val();
            fields['candidate_id'] = $('#candidate_id').val();
            param['fields'] = fields;
            
            var fd = new FormData();
            fd.append('param', JSON.stringify(param));

            //Request API
            $.ajax({
                url: base_url + '/api',
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.status == 1) {
                        window.location.href = redirect;
                    } else {
                        overlay.classList.remove("active");
                        M.toast({ html: response.msg });
                    }                    
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    overlay.classList.remove("active");
                }
            });

            return false;
        });

        // Type Edit Resume
        if (type == 'edit') {
            processPDF();
        }

        /** DOWNLOAD PDF TRIGGER **/
        $('.pdf-navbar .right a').on('click', function(e) {
            /*
            var pdf_id = $('#pdf_id').val();
            
            // URL of the PDF file
            const pdfUrl = base_url + '/cvs/' + pdf_id + '.pdf';
            
            $('<a>', {
                href: pdfUrl,
                target: '_blank',
                download: pdf_id + '.pdf',
            }).appendTo('body')[0].click();
            */
        });

        /** UPLOAD IMAGE TRIGGER**/
        $('.professional-info .cta a').on('click', function() {
            $('#avatar').trigger('click');
            return false;
        });

        /** UPLOAD IMAGE TRIGGER**/
        $('.professional-info .cta input').on('change', function() {
            // URL Photo Init
            var url_photo = '';

            //Check File Type
            var file_type = ''
            var file_size = 5.0
            if (this.files[0]) {
                file_type = this.files[0].type;
                file_size = this.files[0].size;
                file_size = parseFloat(file_size / (1024 ** 2));    
            }

            //Check if File is less than 2MB
            if (file_size <= 5.0)
            {
                $('.professional-info .cta a').addClass('disabled');
                $('.professional-info .cta a').text('Subiendo...');
                $('.professional-info .cta a').attr('data-url','javascript:void(0);');

                var pdf_id = $('#pdf_id').val();

                var param = {
                    "site": "talento",
                    "msg": "saveResumeAvatar",
                    "fields": {
                        "avatar_file_type": file_type,
                        "resume_id": pdf_id
                    }
                };

                var fd = new FormData();
                fd.append('file', this.files[0]);
                fd.append('param', JSON.stringify(param));

                $.ajax({
                    url: base_url + '/api',
                    data: fd,
                    processData: false,
                    contentType: false,
                    type: 'POST',
                    success: function (data) {
                        //Check Result
                        if (data.status == 1) {
                            //Change Image
                            $('.professional-info .avatar img').attr('src', data.base64);
                            $('.professional-info .cta a').removeClass('disabled');
                            $('.professional-info .cta a').text('Subir Fotografía');
                            $('.professional-info #url_photo').val(data.data);
                            $('.professional-info #url_photo64').val(data.base64);
                            processPDF('url_photo');
                        } else {
                            //Show Error
                            M.toast({ html: data.data });
                            $('.professional-info .cta a').removeClass('disabled');
                            $('.professional-info .cta a').text('Subir Fotografía');
                        }
                    }
                });
            }
            else
            {
                M.toast({ html: "El límite de tamaño del comprobante es de 2MB. Selecciona otro archivo." });
            }
        });

        /** ADD NEW LANGUAGE */
        $('.languages_cta a').off('click').on('click', function(e) {
            e.preventDefault();

            var count = $('#other_languages').val();
            count = parseInt(count) + 1;

            //Clear Language Fields
            $('#other_languages_id_' + count).val('');
            $('#language_name_' + count).val('');
            $('#language_level_' + count).val('');

            //Add Language
            $('#language_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#other_languages').val(count.toString());

            //Hide Add Language Button
            if (count == 5) {
                $('.languages_cta').fadeOut(0);
            }

            if (count == 2) {
                $('.delete_language').fadeIn('slow');
            }

            return false;
        });

        /** DELETE LANGUAGE */
        $('.delete_language a').off('click').on('click', function(e) {
            e.preventDefault();

            var count = $('#other_languages').val();
            
            //Remove Language
            $('#language_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#other_languages_id_' + count).val('');
            $('#language_name_' + count).val('');
            $('#language_level_' + count).val('');
            
            //Decrement Language Count
            $('#other_languages').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count == 5) {
                $('.languages_cta').fadeIn('slow');
            }

            if (count == 2) {
                $('.delete_language').fadeOut(0);
            }

            processPDF('other_languages');

            return false;
        });

        /** ADD NEW EXPERIENCE */
        $('.professional-experience_cta a').off('click').on('click', function(e) {
            var count = $('#experience_details').val();
            count = parseInt(count) + 1;
            
            //Clear Language Fields
            $('#experience_details_id_' + count).val('');
            $('#occupation_title_' + count).val('');
            $('#company_' + count).val('');
            $('#start_date_month_' + count).val('');
            $('#start_date_year_' + count).val('');
            $('#end_date_month_' + count).val('');
            $('#end_date_year_' + count).val('');
            if (count == 2) { description_2_editor.setValue(''); }
            if (count == 3) { description_3_editor.setValue(''); }
            if (count == 4) { description_4_editor.setValue(''); }
            if (count == 5) { description_5_editor.setValue(''); }

            //Add Language
            $('#professional-experience_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#experience_details').val(count.toString());

            //Hide Add Language Button
            if (count == 5) {
                $('.professional-experience_cta').fadeOut(0);
            }

            //Hide Delete Experience Button
            if (count == 2) {
                $('.delete_experience').fadeIn('slow');
            }

            return false;
        });

        /** DELETE EXPERIENCE */
        $('.delete_experience a').off('click').on('click', function(e) {
            e.preventDefault();

            var count = $('#experience_details').val();
            
            //Remove Language
            $('#professional-experience_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#experience_details_id_' + count).val('');
            $('#occupation_title_' + count).val('');
            $('#company_' + count).val('');
            $('#start_date_month_' + count).val('');
            $('#start_date_year_' + count).val('');
            $('#end_date_month_' + count).val('');
            $('#end_date_year_' + count).val('');
            if (count == 2) { description_2_editor.setValue(''); }
            if (count == 3) { description_3_editor.setValue(''); }
            if (count == 4) { description_4_editor.setValue(''); }
            if (count == 5) { description_5_editor.setValue(''); }

            //Decrement Language Count
            $('#experience_details').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count == '5') {
                $('.professional-experience_cta').fadeIn('slow');
            }

            //Hide Delete Experience Button
            if (count == '2') {
                $('.delete_experience').fadeOut(0);
            }

            processPDF('experience_details');

            return false;
        });

        /** ADD NEW SKILL */
        $('.skills_cta a').off('click').on('click', function(e) {
            e.preventDefault();

            var count = $('#skills').val();
            count = parseInt(count) + 1;

            //Clear Language Fields
            $('#other_skill_' + count).val('');
            $('#n_' + count + '_year_of_experience' + count).val('');

            //Add Language
            $('.skills_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#skills').val(count.toString());

            //Hide Add Language Button
            if (count == 10) {
                $('.skills_cta').fadeOut(0);
            }

            if (count > 3) {
                $('.delete_skill').fadeIn('slow');
            }

            return false;
        });


        


        /** DELETE SKILL */
        $('.delete_skill a').off('click').on('click', function(e) {
            e.preventDefault();

            var count = $('#skills').val();
            
            //Remove Language
            $('.skills_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#other_skill_' + count).val('');
            $('#n_' + count + '_year_of_experience' + count).val('');
            
            //Decrement Language Count
            $('#skills').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count > 3) {
                $('.skills_cta').fadeIn('slow');
            }

            if (count == 4) {
                $('.delete_skill').fadeOut(0);
            }

            processPDF('skills');

            return false;
        });

        /** ADD EDUCATION */
        $('.education_cta a').off('click').on('click', function(e){
            var count = $('#educational_details').val();
            count = parseInt(count) + 1;
            
            //Clear Language Fields
            $('#major_department_' + count).val('');
            $('#currently_pursuing_' + count).val('');
            $('#education_details_id_' + count).val('');
            $('#degree_'+ count).val('');
            $('#institute_school_' + count).val('');
            $('#education_start_date_month_' + count).val('');
            $('#education_start_date_year_' + count).val('');
            $('#education_end_date_month_' + count).val('');
            $('#education_end_date_year_' + count).val('');

            //Add Language
            $('.education_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#educational_details').val(count.toString());

            //Hide Add Language Button
            if (count == 3) {
                $('.education_cta').fadeOut(0);
            }

            //Hide Delete Experience Button
            if (count > 1) {
                $('.delete_education').fadeIn('slow');
            }

            return false;
        });

        /** DELETE EDUCATION */
        $('.delete_education a').off('click').on('click', function(e) {
            e.preventDefault();

            var count = $('#educational_details').val();
            
            //Remove Language
            $('.education_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#major_department_' + count).val('');
            $('#currently_pursuing_' + count).val('');
            $('#education_details_id_' + count).val('');
            $('#degree_'+ count).val('');
            $('#institute_school_' + count).val('');
            $('#education_start_date_month_' + count).val('');
            $('#education_start_date_year_' + count).val('');
            $('#education_end_date_month_' + count).val('');
            $('#education_end_date_year_' + count).val('');

            //Decrement Language Count
            $('#educational_details').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count > 1) {
                $('.education_cta').fadeIn('slow');
            }

            //Hide Delete Experience Button
            if (count == 2) {
                $('.delete_education').fadeOut(0);
            }

            processPDF('educational_details');

            return false;
        });

        /** ADD NEW LINK */
        $('.links_cta a').off('click').on('click', function(e) {
            e.preventDefault();


            var count = $('#portfolio_links').val();
            count = parseInt(count) + 1;

            //Clear Language Fields
            $('#portfolio_links_id_' + count).val('');
            $('#platform_' + count).val('');
            $('#url_' + count).val('');

            //Add Language
            $('.links_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#portfolio_links').val(count.toString());

            //Hide Add Language Button
            if (count == 10) {
                $('.links_cta').fadeOut(0);
            }

            if (count > 1) {
                $('.delete_link').fadeIn('slow');
            }

            return false;
        });

        /** DELETE LINK */
        $('.delete_link a').off('click').on('click', function(e) {
            e.preventDefault();

            var count = $('#portfolio_links').val();
            
            //Remove Language
            $('.links_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#portfolio_links_id_' + count).val('');
            $('#platform_' + count).val('');
            $('#url_' + count).val('');
            
            //Decrement Language Count
            $('#portfolio_links').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count > 1) {
                $('.links_cta').fadeIn('slow');
            }

            if (count == 2) {
                $('.delete_link').fadeOut(0);
            }

            processPDF('portfolio_links');

            return false;
        });

        /** ADD EDUCATION */
        $('.certifications_cta a').off('click').on('click', function(e) {
            var count = $('#certifications').val();
            count = parseInt(count) + 1;
            
            //Clear Language Fields
            $('#certification_id_' + count).val('');
            $('#certification_course_name_' + count).val('');
            $('#certification_institute_school_' + count).val('');
            $('#certification_start_month_' + count).val('');
            $('#certification_start_year_' + count).val('');
            $('#certification_end_month_' + count).val('');
            $('#certification_end_year_' + count).val('');

            //Add Language
            $('.certification_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#certifications').val(count.toString());

            //Hide Add Language Button
            if (count == 3) {
                $('.certifications_cta').fadeOut(0);
            }

            //Hide Delete Experience Button
            if (count > 1) {
                $('.delete_certification').fadeIn('slow');
            }

            return false;
        });

        /** DELETE EDUCATION */
        $('.delete_certification a').off('click').on('click', function(e) {
            e.preventDefault();

            var count = $('#certifications').val();
            
            //Remove Language
            $('.certification_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#certification_id_' + count).val('');
            $('#certification_course_name_' + count).val('');
            $('#certification_institute_school_' + count).val('');
            $('#certification_start_month_' + count).val('');
            $('#certification_start_year_' + count).val('');
            $('#certification_end_month_' + count).val('');
            $('#certification_end_year_' + count).val('');

            //Decrement Language Count
            $('#certifications').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count > 1) {
                $('.certifications_cta').fadeIn('slow');
            }

            //Hide Delete Experience Button
            if (count == 2) {
                $('.delete_certification').fadeOut(0);
            }

            processPDF('certifications');

            return false;
        });

        // Input Change
        $(document).on('change', 'form input[type=text]', function(e) {
            var mw_field = $(this).attr('mw_field');
            if (mw_field == undefined || mw_field == null) { mw_field = ''; }
            var urlMatch = /^url_(\d+)$/.exec(mw_field);
            if (urlMatch) {
                var $portfolioUrlField = $('#' + mw_field);
                if ($portfolioUrlField.length) {
                    $portfolioUrlField.val(cvcreatorNormalizeUrlValue($portfolioUrlField.val()));
                    cvcreatorSyncPortfolioUrlFieldFromInput($portfolioUrlField);
                    var rawUrl = String($portfolioUrlField.val() || '').trim();
                    if (cvcreatorIsValidPortfolioUrl(rawUrl) && $('#platform_' + urlMatch[1]).val() != '' && rawUrl !== '') {
                        processPDF('portfolio_links');
                    }
                }
                return;
            }

            switch (mw_field) {
                // Experience Details
                case 'occupation_title_1':
                case 'company_1':
                    var end_date = false;
                    end_date_month_1 = $('#end_date_month_1').val();
                    end_date_year_1 = $('#end_date_year_1').val();
                    if (end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_1 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_1').val() != '' &&
                        $('#company_1').val() != '' &&
                        $('#start_date_month_1').val() != null &&
                        $('#start_date_year_1').val() != null &&
                        $('#end_date_month_1').val() != null &&
                        end_date &&
                        description_1_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'occupation_title_2':
                case 'company_2':
                    var end_date = false;
                    end_date_month_2 = $('#end_date_month_2').val();
                    end_date_year_2 = $('#end_date_year_2').val();
                    if (end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_2 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_2').val() != '' &&
                        $('#company_2').val() != '' &&
                        $('#start_date_month_2').val() != null &&
                        $('#start_date_year_2').val() != null &&
                        $('#end_date_month_2').val() != null &&
                        end_date &&
                        description_2_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'occupation_title_3':
                case 'company_3':
                    var end_date = false;
                    end_date_month_3 = $('#end_date_month_3').val();
                    end_date_year_3 = $('#end_date_year_3').val();
                    if (end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_3 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_3').val() != '' &&
                        $('#company_3').val() != '' &&
                        $('#start_date_month_3').val() != null &&
                        $('#start_date_year_3').val() != null &&
                        $('#end_date_month_3').val() != null &&
                        end_date &&
                        description_3_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'occupation_title_4':
                case 'company_4':
                    var end_date = false;
                    end_date_month_4 = $('#end_date_month_4').val();
                    end_date_year_4 = $('#end_date_year_4').val();
                    if (end_date_month_4 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_4 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_4').val() != '' &&
                        $('#company_4').val() != '' &&
                        $('#start_date_month_4').val() != null &&
                        $('#start_date_year_4').val() != null &&
                        $('#end_date_month_4').val() != null &&
                        end_date &&
                        description_4_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'occupation_title_5':
                case 'company_5':
                    var end_date = false;
                    end_date_month_5 = $('#end_date_month_5').val();
                    end_date_year_5 = $('#end_date_year_5').val();
                    if (end_date_month_5 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_5 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_5').val() != '' &&
                        $('#company_5').val() != '' &&
                        $('#start_date_month_5').val() != null &&
                        $('#start_date_year_5').val() != null &&
                        $('#end_date_month_5').val() != null &&
                        end_date &&
                        description_5_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                // Education Details
                case 'major_department_1':
                case 'institute_school_1':
                    var end_date = false;
                    education_end_date_month_1 = $('#education_end_date_month_1').val();
                    education_end_date_year_1 = $('#education_end_date_year_1').val();
                    if (education_end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_1 != '') { end_date = true; }
                    }

                    if (
                        $('#major_department_1').val() != '' &&
                        $('#institute_school_1').val() != '' &&
                        $('#education_start_date_month_1').val() != null &&
                        $('#education_start_date_year_1').val() != null &&
                        $('#education_end_date_month_1').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                case 'major_department_2':
                case 'institute_school_2':
                    var end_date = false;
                    education_end_date_month_2 = $('#education_end_date_month_2').val();
                    education_end_date_year_2 = $('#education_end_date_year_2').val();
                    if (education_end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_2 != '') { end_date = true; }
                    }

                    if (
                        $('#major_department_2').val() != '' &&
                        $('#institute_school_2').val() != '' &&
                        $('#education_start_date_month_2').val() != null &&
                        $('#education_start_date_year_2').val() != null &&
                        $('#education_end_date_month_2').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                case 'major_department_3':
                case 'institute_school_3':
                    var end_date = false;
                    education_end_date_month_3 = $('#education_end_date_month_3').val();
                    education_end_date_year_3 = $('#education_end_date_year_3').val();
                    if (education_end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_3 != '') { end_date = true; }
                    }

                    if (
                        $('#major_department_3').val() != '' &&
                        $('#institute_school_3').val() != '' &&
                        $('#education_start_date_month_3').val() != null &&
                        $('#education_start_date_year_3').val() != null &&
                        $('#education_end_date_month_3').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                // Certifications
                case 'certification_course_name_1':
                case 'certification_institute_school_1':
                    var end_date = false;
                    education_end_date_month_1 = $('#certification_end_month_1').val();
                    education_end_date_year_1 = $('#certification_end_year_1').val();
                    if (education_end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_1 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_1').val() != '' &&
                        $('#certification_institute_school_1').val() != '' &&
                        $('#certification_start_month_1').val() != null &&
                        $('#certification_start_year_1').val() != null &&
                        $('#certification_end_month_1').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                case 'certification_course_name_2':
                case 'certification_institute_school_2':
                    var end_date = false;
                    education_end_date_month_2 = $('#certification_end_month_2').val();
                    education_end_date_year_2 = $('#certification_end_year_2').val();
                    if (education_end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_2 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_2').val() != '' &&
                        $('#certification_institute_school_2').val() != '' &&
                        $('#certification_start_month_2').val() != null &&
                        $('#certification_start_year_2').val() != null &&
                        $('#certification_end_month_2').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                case 'certification_course_name_3':
                case 'certification_institute_school_3':
                    var end_date = false;
                    education_end_date_month_3 = $('#certification_end_month_3').val();
                    education_end_date_year_3 = $('#certification_end_year_3').val();
                    if (education_end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_3 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_3').val() != '' &&
                        $('#certification_institute_school_3').val() != '' &&
                        $('#certification_start_month_3').val() != null &&
                        $('#certification_start_year_3').val() != null &&
                        $('#certification_end_month_3').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                default:
                    if (mw_field) {
                        processPDF(mw_field);
                    }
                    break;
            }
        });

        // Input Tel Change
        $(document).on('change', 'form input[type=tel]', function(e) {
            var mw_field = $(this).attr('mw_field');
            if (mw_field == undefined || mw_field == null) { mw_field = ''; }
            processPDF(mw_field);            
        });

        // Select Change
        $(document).on('change', 'form select', function(e) {
            var mw_field = $(this).attr('mw_field');
            if (mw_field == undefined || mw_field == null) { mw_field = ''; }
            
            switch (mw_field) {
                // Other Languages
                case 'language_name_1':
                case 'language_level_1':
                    if ($('#language_name_1').val() != null && $('#language_level_1').val() != null) { processPDF('other_languages'); }
                    break;
                case 'language_name_2':
                case 'language_level_2':
                    if ($('#language_name_2').val() != null && $('#language_level_2').val() != null) { processPDF('other_languages'); }
                    break;
                case 'language_name_3':
                case 'language_level_3':
                    if ($('#language_name_3').val() != null && $('#language_level_3').val() != null) { processPDF('other_languages'); }
                    break;
                case 'language_name_4':
                case 'language_level_4':
                    if ($('#language_name_4').val() != null && $('#language_level_4').val() != null) { processPDF('other_languages'); }
                    break;
                case 'language_name_5':
                case 'language_level_5':
                    if ($('#language_name_5').val() != null && $('#language_level_5').val() != null) { processPDF('other_languages'); }
                    break;
                // Experience Details
                case 'start_date_month_1':
                case 'start_date_year_1':
                case 'end_date_month_1':
                case 'end_date_year_1':
                    var end_date = false;
                    end_date_month_1 = $('#end_date_month_1').val();
                    end_date_year_1 = $('#end_date_year_1').val();
                    if (end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_1 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_1').val() != '' &&
                        $('#company_1').val() != '' &&
                        $('#start_date_month_1').val() != null &&
                        $('#start_date_year_1').val() != null &&
                        $('#end_date_month_1').val() != null &&
                        end_date &&
                        description_1_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'start_date_month_2':
                case 'start_date_year_2':
                case 'end_date_month_2':
                case 'end_date_year_2':
                    var end_date = false;
                    end_date_month_2 = $('#end_date_month_2').val();
                    end_date_year_2 = $('#end_date_year_2').val();
                    if (end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_2 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_2').val() != '' &&
                        $('#company_2').val() != '' &&
                        $('#start_date_month_2').val() != '' &&
                        $('#start_date_year_2').val() != '' &&
                        $('#end_date_month_2').val() != '' &&
                        end_date &&
                        description_2_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'start_date_month_3':
                case 'start_date_year_3':
                case 'end_date_month_3':
                case 'end_date_year_3':
                    var end_date = false;
                    end_date_month_3 = $('#end_date_month_3').val();
                    end_date_year_3 = $('#end_date_year_3').val();
                    if (end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_3 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_3').val() != '' &&
                        $('#company_3').val() != '' &&
                        $('#start_date_month_3').val() != null &&
                        $('#start_date_year_3').val() != null &&
                        $('#end_date_month_3').val() != null &&
                        end_date &&
                        description_3_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'start_date_month_4':
                case 'start_date_year_4':
                case 'end_date_month_4':
                case 'end_date_year_4':
                    var end_date = false;
                    end_date_month_4 = $('#end_date_month_4').val();
                    end_date_year_4 = $('#end_date_year_4').val();
                    if (end_date_month_4 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_4 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_4').val() != '' &&
                        $('#company_4').val() != '' &&
                        $('#start_date_month_4').val() != null &&
                        $('#start_date_year_4').val() != null &&
                        $('#end_date_month_4').val() != null &&
                        end_date &&
                        description_4_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'start_date_month_5':
                case 'start_date_year_5':
                case 'end_date_month_5':
                case 'end_date_year_5':
                    var end_date = false;
                    end_date_month_5 = $('#end_date_month_5').val();
                    end_date_year_5 = $('#end_date_year_5').val();
                    if (end_date_month_5 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_5 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_5').val() != '' &&
                        $('#company_5').val() != '' &&
                        $('#start_date_month_5').val() != null &&
                        $('#start_date_year_5').val() != null &&
                        $('#end_date_month_5').val() != null &&
                        end_date &&
                        description_5_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                // Skills
                case 'primary_skill':
                case 'n_1_year_of_experience':
                    if ($('#primary_skill').val() != null && $('#n_1_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'secondary_skill':
                case 'n_2_year_of_experience':
                    if ($('#secondary_skill').val() != null && $('#n_2_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'third_skill':
                case 'n_3_year_of_experience':
                    if ($('#third_skill').val() != null && $('#n_3_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_4':
                case 'n_4_year_of_experience':
                    if ($('#other_skill_4').val() != null && $('#n_4_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_5':
                case 'n_5_year_of_experience':
                    if ($('#other_skill_5').val() != null && $('#n_5_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_6':
                case 'n_6_year_of_experience':
                    if ($('#other_skill_6').val() != null && $('#n_6_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_7':
                case 'n_7_year_of_experience':
                    if ($('#other_skill_7').val() != null && $('#n_7_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_8':
                case 'n_8_year_of_experience':
                    if ($('#other_skill_8').val() != null && $('#n_8_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_9':
                case 'n_9_year_of_experience':
                    if ($('#other_skill_9').val() != null && $('#n_9_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_10':
                case 'n_10_year_of_experience':
                    if ($('#other_skill_10').val() != null && $('#n_10_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                // Portfolio Links
                case 'platform_1': {
                    var raw_p1 = $('#url_1').val();
                    if (raw_p1.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p1)) {
                        cvcreatorSetPortfolioUrlErrorState(1, true);
                        break;
                    }
                    if ($('#platform_1').val() != null && raw_p1.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_2': {
                    var raw_p2 = $('#url_2').val();
                    if (raw_p2.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p2)) {
                        cvcreatorSetPortfolioUrlErrorState(2, true);
                        break;
                    }
                    if ($('#platform_2').val() != null && raw_p2.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_3': {
                    var raw_p3 = $('#url_3').val();
                    if (raw_p3.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p3)) {
                        cvcreatorSetPortfolioUrlErrorState(3, true);
                        break;
                    }
                    if ($('#platform_3').val() != null && raw_p3.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_4': {
                    var raw_p4 = $('#url_4').val();
                    if (raw_p4.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p4)) {
                        cvcreatorSetPortfolioUrlErrorState(4, true);
                        break;
                    }
                    if ($('#platform_4').val() != null && raw_p4.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_5': {
                    var raw_p5 = $('#url_5').val();
                    if (raw_p5.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p5)) {
                        cvcreatorSetPortfolioUrlErrorState(5, true);
                        break;
                    }
                    if ($('#platform_5').val() != null && raw_p5.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_6': {
                    var raw_p6 = $('#url_6').val();
                    if (raw_p6.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p6)) {
                        cvcreatorSetPortfolioUrlErrorState(6, true);
                        break;
                    }
                    if ($('#platform_6').val() != null && raw_p6.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_7': {
                    var raw_p7 = $('#url_7').val();
                    if (raw_p7.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p7)) {
                        cvcreatorSetPortfolioUrlErrorState(7, true);
                        break;
                    }
                    if ($('#platform_7').val() != null && raw_p7.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_8': {
                    var raw_p8 = $('#url_8').val();
                    if (raw_p8.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p8)) {
                        cvcreatorSetPortfolioUrlErrorState(8, true);
                        break;
                    }
                    if ($('#platform_8').val() != null && raw_p8.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_9': {
                    var raw_p9 = $('#url_9').val();
                    if (raw_p9.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p9)) {
                        cvcreatorSetPortfolioUrlErrorState(9, true);
                        break;
                    }
                    if ($('#platform_9').val() != null && raw_p9.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_10': {
                    var raw_p10 = $('#url_10').val();
                    if (raw_p10.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p10)) {
                        cvcreatorSetPortfolioUrlErrorState(10, true);
                        break;
                    }
                    if ($('#platform_10').val() != null && raw_p10.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                // Education Details
                case 'education_start_date_month_1':
                case 'education_start_date_year_1':
                case 'education_end_date_month_1':
                case 'education_end_date_year_1':
                    var end_date = false;
                    education_end_date_month_1 = $('#education_end_date_month_1').val();
                    education_end_date_year_1 = $('#education_end_date_year_1').val();
                    if (education_end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_1 != null) { end_date = true; }
                    }

                    if (
                        $('#major_department_1').val() != '' &&
                        $('#institute_school_1').val() != '' &&
                        $('#education_start_date_month_1').val() != null &&
                        $('#education_start_date_year_1').val() != null &&
                        $('#education_end_date_month_1').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                case 'education_start_date_month_2':
                case 'education_start_date_year_2':
                case 'education_end_date_month_2':
                case 'education_end_date_year_2':
                    var end_date = false;
                    education_end_date_month_2 = $('#education_end_date_month_2').val();
                    education_end_date_year_2 = $('#education_end_date_year_2').val();
                    if (education_end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_2 != null) { end_date = true; }
                    }

                    if (
                        $('#major_department_2').val() != '' &&
                        $('#institute_school_2').val() != '' &&
                        $('#education_start_date_month_2').val() != null &&
                        $('#education_start_date_year_2').val() != null &&
                        $('#education_end_date_month_2').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                case 'education_start_date_month_3':
                case 'education_start_date_year_3':
                case 'education_end_date_month_3':
                case 'education_end_date_year_3':
                    var end_date = false;
                    education_end_date_month_3 = $('#education_end_date_month_3').val();
                    education_end_date_year_3 = $('#education_end_date_year_3').val();
                    if (education_end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_3 != null) { end_date = true; }
                    }

                    if (
                        $('#major_department_3').val() != '' &&
                        $('#institute_school_3').val() != '' &&
                        $('#education_start_date_month_3').val() != null &&
                        $('#education_start_date_year_3').val() != null &&
                        $('#education_end_date_month_3').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                // Certifications
                case 'certification_start_month_1':
                case 'certification_start_year_1':
                case 'certification_end_month_1':
                case 'certification_end_year_1':
                    var end_date = false;
                    education_end_date_month_1 = $('#certification_end_month_1').val();
                    education_end_date_year_1 = $('#certification_end_year_1').val();
                    if (education_end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_1 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_1').val() != '' &&
                        $('#certification_institute_school_1').val() != '' &&
                        $('#certification_start_month_1').val() != null &&
                        $('#certification_start_year_1').val() != null &&
                        $('#certification_end_month_1').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                case 'certification_start_month_2':
                case 'certification_start_year_2':
                case 'certification_end_month_2':
                case 'certification_end_year_2':
                    var end_date = false;
                    education_end_date_month_2 = $('#certification_end_month_2').val();
                    education_end_date_year_2 = $('#certification_end_year_2').val();
                    if (education_end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_2 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_2').val() != '' &&
                        $('#certification_institute_school_2').val() != '' &&
                        $('#certification_start_month_2').val() != null &&
                        $('#certification_start_year_2').val() != null &&
                        $('#certification_end_month_2').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                case 'certification_start_month_3':
                case 'certification_start_year_3':
                case 'certification_end_month_3':
                case 'certification_end_year_3':
                    var end_date = false;
                    education_end_date_month_3 = $('#certification_end_month_3').val();
                    education_end_date_year_3 = $('#certification_end_year_3').val();
                    if (education_end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_3 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_3').val() != '' &&
                        $('#certification_institute_school_3').val() != '' &&
                        $('#certification_start_month_3').val() != null &&
                        $('#certification_start_year_3').val() != null &&
                        $('#certification_end_month_3').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                default:
                    if (mw_field) {
                        processPDF(mw_field);
                    }
                    break;
            }
        });

        function processPDF(mw_field) {
            var param = {
                "site": "talento", "msg": "processCVCandidate",
            };
            var fields = {};
            fields['language'] = $('#language').val();
            fields['type'] = $('#type').val();
            fields['pdf_id'] = $('#pdf_id').val();
            fields['candidate_id'] = $('#candidate_id').val();
            fields['original_type'] = $('#original_type').val();
            fields['first_name'] = $('#first_name').val();
            fields['last_name'] = $('#last_name').val();
            fields['second_last_name'] = $('#second_last_name').val();
            fields['email'] = $('#email').val();
            fields['mobile'] = $('#mobile').val();
            fields['url_photo'] = $('#url_photo').val();
            fields['url_photo64'] = $('#url_photo64').val();
            fields['current_job_title'] = $('#current_job_title').val();
            fields['years_of_experience'] = $('#years_of_experience').val();
            fields['country'] = $('#country').val();
            fields['state_province'] = $('#state').val();
            fields['city'] = $('#city').val();
            fields['email'] = $('#email').val();
            fields['mobile'] = $('#mobile').val();
            
            fields['professional_summary'] = resume_editor.getValue();
            
            fields['primary_skill'] = $('#primary_skill').val();
            fields['n_1_year_of_experience'] = $('#n_1_year_of_experience').val();
            fields['secondary_skill'] = $('#secondary_skill').val();
            fields['n_2_year_of_experience'] = $('#n_2_year_of_experience').val();
            fields['third_skill'] = $('#third_skill').val();
            fields['n_3_year_of_experience'] = $('#n_3_year_of_experience').val();
            fields['other_skill_4'] = $('#other_skill_4').val();
            fields['n_4_year_of_experience'] = $('#n_4_year_of_experience').val();
            fields['other_skill_5'] = $('#other_skill_5').val();
            fields['n_5_year_of_experience'] = $('#n_5_year_of_experience').val();
            fields['other_skill_6'] = $('#other_skill_6').val();
            fields['n_6_year_of_experience'] = $('#n_6_year_of_experience').val();
            fields['other_skill_7'] = $('#other_skill_7').val();
            fields['n_7_year_of_experience'] = $('#n_7_year_of_experience').val();
            fields['other_skill_8'] = $('#other_skill_8').val();
            fields['n_8_year_of_experience'] = $('#n_8_year_of_experience').val();
            fields['other_skill_9'] = $('#other_skill_9').val();
            fields['n_9_year_of_experience'] = $('#n_9_year_of_experience').val();
            fields['other_skill_10'] = $('#other_skill_10').val();
            fields['n_10_year_of_experience'] = $('#n_10_year_of_experience').val();
            
            fields['language_name_1'] = ($('#language_name_1').val()) ? $('#language_name_1').val() : '';
            fields['language_level_1'] = ($('#language_level_1').val()) ? $('#language_level_1').val() : '';
            fields['language_name_2'] = ($('#language_name_2').val()) ? $('#language_name_2').val() : '';
            fields['language_level_2'] = ($('#language_level_2').val()) ? $('#language_level_2').val() : '';
            fields['language_name_3'] = ($('#language_name_3').val()) ? $('#language_name_3').val() : '';
            fields['language_level_3'] = ($('#language_level_3').val()) ? $('#language_level_3').val() : '';
            fields['language_name_4'] = ($('#language_name_4').val()) ? $('#language_name_4').val() : '';
            fields['language_level_4'] = ($('#language_level_4').val()) ? $('#language_level_4').val() : '';
            fields['language_name_5'] = ($('#language_name_5').val()) ? $('#language_name_5').val() : '';
            fields['language_level_5'] = ($('#language_level_5').val()) ? $('#language_level_5').val() : '';
            
            fields['occupation_title_1'] = ($('#occupation_title_1').val()) ? $('#occupation_title_1').val().trim() : '';
            fields['company_1'] = ($('#company_1').val()) ? $('#company_1').val().trim() : '';
            fields['start_date_month_1'] = ($('#start_date_month_1').val()) ? $('#start_date_month_1').val().trim() : '';
            fields['start_date_year_1'] = ($('#start_date_year_1').val()) ? $('#start_date_year_1').val().trim() : '';
            fields['end_date_month_1'] = ($('#end_date_month_1').val()) ? $('#end_date_month_1').val().trim() : '';
            fields['end_date_year_1'] = ($('#end_date_year_1').val()) ? $('#end_date_year_1').val().trim() : '';
            fields['description_1'] = ($('#description_1').val()) ? $('#description_1').val().trim() : '';
            fields['occupation_title_2'] = ($('#occupation_title_2').val()) ? $('#occupation_title_2').val().trim() : '';
            fields['company_2'] = ($('#company_2').val()) ? $('#company_2').val().trim() : '';
            fields['start_date_month_2'] = ($('#start_date_month_2').val()) ? $('#start_date_month_2').val().trim() : '';
            fields['start_date_year_2'] = ($('#start_date_year_2').val()) ? $('#start_date_year_2').val().trim() : '';
            fields['end_date_month_2'] = ($('#end_date_month_2').val()) ? $('#end_date_month_2').val().trim() : '';
            fields['end_date_year_2'] = ($('#end_date_year_2').val()) ? $('#end_date_year_2').val().trim() : '';
            fields['description_2'] = ($('#description_2').val()) ? $('#description_2').val().trim() : '';
            fields['occupation_title_3'] = ($('#occupation_title_3').val()) ? $('#occupation_title_3').val().trim() : '';
            fields['company_3'] = ($('#company_3').val()) ? $('#company_3').val().trim() : '';
            fields['start_date_month_3'] = ($('#start_date_month_3').val()) ? $('#start_date_month_3').val().trim() : '';
            fields['start_date_year_3'] = ($('#start_date_year_3').val()) ? $('#start_date_year_3').val().trim() : '';
            fields['end_date_month_3'] = ($('#end_date_month_3').val()) ? $('#end_date_month_3').val().trim() : '';
            fields['end_date_year_3'] = ($('#end_date_year_3').val()) ? $('#end_date_year_3').val().trim() : '';
            fields['description_3'] = ($('#description_3').val()) ? $('#description_3').val().trim() : '';
            fields['occupation_title_4'] = ($('#occupation_title_4').val()) ? $('#occupation_title_4').val().trim() : '';
            fields['company_4'] = ($('#company_4').val()) ? $('#company_4').val().trim() : '';
            fields['start_date_month_4'] = ($('#start_date_month_4').val()) ? $('#start_date_month_4').val().trim() : '';
            fields['start_date_year_4'] = ($('#start_date_year_4').val()) ? $('#start_date_year_4').val().trim() : '';
            fields['end_date_month_4'] = ($('#end_date_month_4').val()) ? $('#end_date_month_4').val().trim() : '';
            fields['end_date_year_4'] = ($('#end_date_year_4').val()) ? $('#end_date_year_4').val().trim() : '';
            fields['description_4'] = ($('#description_4').val()) ? $('#description_4').val().trim() : '';
            fields['occupation_title_5'] = ($('#occupation_title_5').val()) ? $('#occupation_title_5').val().trim() : '';
            fields['company_5'] = ($('#company_5').val()) ? $('#company_5').val().trim() : '';
            fields['start_date_month_5'] = ($('#start_date_month_5').val()) ? $('#start_date_month_5').val().trim() : '';
            fields['start_date_year_5'] = ($('#start_date_year_5').val()) ? $('#start_date_year_5').val().trim() : '';
            fields['end_date_month_5'] = ($('#end_date_month_5').val()) ? $('#end_date_month_5').val().trim() : '';
            fields['end_date_year_5'] = ($('#end_date_year_5').val()) ? $('#end_date_year_5').val().trim() : '';
            fields['description_5'] = ($('#description_5').val()) ? $('#description_5').val().trim() : '';

            fields['major_department_1'] = ($('#major_department_1').val()) ? $('#major_department_1').val().trim() : '';
            fields['currently_pursuing_1'] = ($('#currently_pursuing_1').val()) ? $('#currently_pursuing_1').val().trim() : '';
            fields['education_details_id_1'] = ($('#education_details_id_1').val()) ? $('#education_details_id_1').val().trim() : '';
            fields['degree_1'] = ($('#degree_1').val()) ? $('#degree_1').val().trim() : '';
            fields['institute_school_1'] = ($('#institute_school_1').val()) ? $('#institute_school_1').val().trim() : '';
            fields['education_start_date_month_1'] = ($('#education_start_date_month_1').val()) ? $('#education_start_date_month_1').val().trim() : '';
            fields['education_start_date_year_1'] = ($('#education_start_date_year_1').val()) ? $('#education_start_date_year_1').val().trim() : '';
            fields['education_end_date_month_1'] = ($('#education_end_date_month_1').val()) ? $('#education_end_date_month_1').val().trim() : '';
            fields['education_end_date_year_1'] = ($('#education_end_date_year_1').val()) ? $('#education_end_date_year_1').val().trim() : '';
            fields['major_department_2'] = ($('#major_department_2').val()) ? $('#major_department_2').val().trim() : '';
            fields['currently_pursuing_2'] = ($('#currently_pursuing_2').val()) ? $('#currently_pursuing_2').val().trim() : '';
            fields['education_details_id_2'] = ($('#education_details_id_2').val()) ? $('#education_details_id_2').val().trim() : '';
            fields['degree_2'] = ($('#degree_2').val()) ? $('#degree_2').val().trim() : '';
            fields['institute_school_2'] = ($('#institute_school_2').val()) ? $('#institute_school_2').val().trim() : '';
            fields['education_start_date_month_2'] = ($('#education_start_date_month_2').val()) ? $('#education_start_date_month_2').val().trim() : '';
            fields['education_start_date_year_2'] = ($('#education_start_date_year_2').val()) ? $('#education_start_date_year_2').val().trim() : '';
            fields['education_end_date_month_2'] = ($('#education_end_date_month_2').val()) ? $('#education_end_date_month_2').val().trim() : '';
            fields['education_end_date_year_2'] = ($('#education_end_date_year_2').val()) ? $('#education_end_date_year_2').val().trim() : '';
            fields['major_department_3'] = ($('#major_department_3').val()) ? $('#major_department_3').val().trim() : '';
            fields['currently_pursuing_3'] = ($('#currently_pursuing_3').val()) ? $('#currently_pursuing_3').val().trim() : '';
            fields['education_details_id_3'] = ($('#education_details_id_3').val()) ? $('#education_details_id_3').val().trim() : '';
            fields['degree_3'] = ($('#degree_3').val()) ? $('#degree_3').val().trim() : '';
            fields['institute_school_3'] = ($('#institute_school_3').val()) ? $('#institute_school_3').val().trim() : '';
            fields['education_start_date_month_3'] = ($('#education_start_date_month_3').val()) ? $('#education_start_date_month_3').val().trim() : '';
            fields['education_start_date_year_3'] = ($('#education_start_date_year_3').val()) ? $('#education_start_date_year_3').val().trim() : '';
            fields['education_end_date_month_3'] = ($('#education_end_date_month_3').val()) ? $('#education_end_date_month_3').val().trim() : '';
            fields['education_end_date_year_3'] = ($('#education_end_date_year_3').val()) ? $('#education_end_date_year_3').val().trim() : '';

            cvcreatorApplyPortfolioFieldsForPdf(fields);

            fields['certification_id_1'] = ($('#certification_id_1').val()) ? $('#certification_id_1').val().trim() : '';
            fields['certification_course_name_1'] = ($('#certification_course_name_1').val()) ? $('#certification_course_name_1').val().trim() : '';
            fields['certification_institute_school_1'] = ($('#certification_institute_school_1').val()) ? $('#certification_institute_school_1').val().trim() : '';
            fields['certification_start_month_1'] = ($('#certification_start_month_1').val()) ? $('#certification_start_month_1').val().trim() : '';
            fields['certification_start_year_1'] = ($('#certification_start_year_1').val()) ? $('#certification_start_year_1').val().trim() : '';
            fields['certification_end_month_1'] = ($('#certification_end_month_1').val()) ? $('#certification_end_month_1').val().trim() : '';
            fields['certification_end_year_1'] = ($('#certification_end_year_1').val()) ? $('#certification_end_year_1').val().trim() : '';
            fields['certification_id_2'] = ($('#certification_id_2').val()) ? $('#certification_id_2').val().trim() : '';
            fields['certification_course_name_2'] = ($('#certification_course_name_2').val()) ? $('#certification_course_name_2').val().trim() : '';
            fields['certification_institute_school_2'] = ($('#certification_institute_school_2').val()) ? $('#certification_institute_school_2').val().trim() : '';
            fields['certification_start_month_2'] = ($('#certification_start_month_2').val()) ? $('#certification_start_month_2').val().trim() : '';
            fields['certification_start_year_2'] = ($('#certification_start_year_2').val()) ? $('#certification_start_year_2').val().trim() : '';
            fields['certification_end_month_2'] = ($('#certification_end_month_2').val()) ? $('#certification_end_month_2').val().trim() : '';
            fields['certification_end_year_2'] = ($('#certification_end_year_2').val()) ? $('#certification_end_year_2').val().trim() : '';
            fields['certification_id_3'] = ($('#certification_id_3').val()) ? $('#certification_id_3').val().trim() : '';
            fields['certification_course_name_3'] = ($('#certification_course_name_3').val()) ? $('#certification_course_name_3').val().trim() : '';
            fields['certification_institute_school_3'] = ($('#certification_institute_school_3').val()) ? $('#certification_institute_school_3').val().trim() : '';
            fields['certification_start_month_3'] = ($('#certification_start_month_3').val()) ? $('#certification_start_month_3').val().trim() : '';
            fields['certification_start_year_3'] = ($('#certification_start_year_3').val()) ? $('#certification_start_year_3').val().trim() : '';
            fields['certification_end_month_3'] = ($('#certification_end_month_3').val()) ? $('#certification_end_month_3').val().trim() : '';
            fields['certification_end_year_3'] = ($('#certification_end_year_3').val()) ? $('#certification_end_year_3').val().trim() : '';
            
            fields['mw_field'] = mw_field;
            param['fields'] = fields;
            
            $(".pdf-navbar .left").html('<i class="fas fa-cloud-upload-alt"></i> Procesando...');
            $(".pdf-loader").html('<div class="spinner"><div class="preloader-wrapper small active"><div class="spinner-layer spinner-blue-only"><div class="circle-clipper left"><div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div></div>');

            
            var fd = new FormData();
            fd.append('param', JSON.stringify(param));
            
            var version = Date.now();
            
            //Request API
            $.ajax({
                url: base_url + '/api',
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                success: function (response) {
                    $(".pdf-navbar .left").html('<i class="fas fa-cloud-upload-alt"></i> Guardado');
                    $(".pdf-loader").html('<div data-pdf="' + template_directory + '/cvs/' + $('#pdf_id').val() + '.pdf?version=' + version + '" data-options="no-print no-download" data-fit="fit" style="width: 100%; height: 100%;"></div>');
                    loadPDFMiniViewers(base_url, function () {
                        PDFMiniViewers.initialize(
                            base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/pdf-worker.js',
                            base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/cmaps'
                        );
                        fitPDFInViewer();
                    });
                } 
            });
            
        }

        // Ver y Descargar Mobile
        $('.switch_mobile .cta button').on('click', function(e) {
            e.preventDefault();

            var status_mobile = $('.switch_mobile #status_mobile').val();
            if (status_mobile == '0') {
                $('.switch_mobile #status_mobile').val('1');
                $('.full-height .form').fadeOut(0);
                $('.full-height .preview').fadeIn('slow');
                processPDF();
            } else {
                $('.switch_mobile #status_mobile').val('0');
                $('.full-height .preview').fadeOut(0);
                $('.full-height .form').fadeIn('slow');
            }

            return false;
        });

        $('.modal').modal({
            onOpenStart: function () {
                var modal_step = $('.cv-creator .cv-creator__modal #modal_step').val();
                
                switch (modal_step) {
                    case '1':
                        $('.cv-creator .cv-creator__modal .step_2').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_3').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_4').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_5').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_1').fadeIn('slow');                        
                        break;
                    case '2':
                        if ($('.cv-creator__form form').valid()) { 
                            $('.cv-creator .cv-creator__modal .step_1').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_2').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_3').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_5').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_4').fadeIn('slow');
                        } else {
                            $('.cv-creator .cv-creator__modal .step_1').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_3').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_4').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_5').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_2').fadeIn('slow');
                        }
                        break;
                    case '3':
                        if ($('.cv-creator__form form').valid()) { 
                            $('.cv-creator .cv-creator__modal .step_1').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_2').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_3').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_5').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_4').fadeIn('slow');
                        } else {
                            $('.cv-creator .cv-creator__modal .step_1').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_2').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_4').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_5').fadeOut(0);
                            $('.cv-creator .cv-creator__modal .step_3').fadeIn('slow');
                        }
                        break;
                    case '4':
                        $('.cv-creator .cv-creator__modal .step_1').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_2').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_3').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_5').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_4').fadeIn('slow');
                        break;
                    case '5':
                        $('.cv-creator .cv-creator__modal .step_1').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_2').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_3').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_4').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_5').fadeIn('slow');
                        break;
                    default:
                        $('.cv-creator .cv-creator__modal .step_2').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_3').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_4').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_5').fadeOut(0);
                        $('.cv-creator .cv-creator__modal .step_1').fadeIn('slow');
                        break;
                }
                
            }
        });

        /** DOWNLOAD CV FROM MODAL */
        $('.cv-creator__modal .step_1 .download-cv').on('click', function() {
            var pdf_id = $('#pdf_id').val();
            
            // URL of the PDF file
            const pdfUrl = template_directory + '/cvs/' + pdf_id + '.pdf';
            
            $('<a>', {
                href: pdfUrl,
                target: '_blank',
                download: pdf_id + '.pdf',
            }).appendTo('body')[0].click();

            $('.modal').modal('close');
        });

        // Validate CV Fields
        $(".cv-creator__form .form form").validate({
            rules: {
                first_name: {
                    required: true
                },
                last_name: {
                    required: true
                },
                second_last_name: {
                    required: true
                },
                mobile: {
                    required: true
                },
                email: {
                    required: true,
                    email: true
                },
                current_job_title: {
                    required: true
                },
                years_of_experience: {
                    required: true
                },
                primary_skill: {
                    required: true
                },
                n_1_year_of_experience: {
                    required: true
                },
                secondary_skill: {
                    required: true
                },
                n_2_year_of_experience: {
                    required: true
                },
                third_skill: {
                    required: true
                },
                n_3_year_of_experience: {
                    required: true
                },
                country: {
                    required: true
                },
                state: {
                    required: true
                },
                city: {
                    required: true
                }
            },
            errorPlacement: function (error, element) { }
        });

        // Modal CTA
        $('.cv-creator .cv-creator__modal #form-agency-step1 .cta-agency button').click(function(e) {
            e.preventDefault();

            if ($('.cv-creator__form form').valid()) {
                $('.cv-creator .cv-creator__modal .step_1').fadeOut(0);
                $('.cv-creator .cv-creator__modal .step_2').fadeOut(0);
                $('.cv-creator .cv-creator__modal .step_3').fadeOut(0);
                $('.cv-creator .cv-creator__modal .step_5').fadeOut(0);
                $('.cv-creator .cv-creator__modal .step_4').fadeIn('slow');

                $('.cv-creator .cv-creator__modal #modal_step').val('4');
            } else {
                $('.cv-creator .cv-creator__modal .step_1').fadeOut(0);
                $('.cv-creator .cv-creator__modal .step_3').fadeOut(0);
                $('.cv-creator .cv-creator__modal .step_4').fadeOut(0);
                $('.cv-creator .cv-creator__modal .step_5').fadeOut(0);
                $('.cv-creator .cv-creator__modal .step_2').fadeIn('slow');

                $('.cv-creator .cv-creator__modal #modal_step').val('3');
            }

            return false;
        });

        /** DOWNLOAD CV FROM MODAL */
        $('.cv-creator__modal .step_2 .return-cv').on('click', function() {

            $('.modal').modal('close');

            $('.cv-creator .cv-creator__modal #modal_step').val('3');

        });

        /** DOWNLOAD CV FROM MODAL */
        $('.cv-creator__modal .step_2 .download-cv').on('click', function() {
            var pdf_id = $('#pdf_id').val();
            
            // URL of the PDF file
            const pdfUrl = template_directory + '/cvs/' + pdf_id + '.pdf';
            
            $('<a>', {
                href: pdfUrl,
                target: '_blank',
                download: pdf_id + '.pdf',
            }).appendTo('body')[0].click();

            $('.modal').modal('close');

            $('.cv-creator .cv-creator__modal #modal_step').val('1');
        });

        /** DOWNLOAD CV FROM MODAL */
        $('.cv-creator__modal .step_3 .return-cv').on('click', function() {

            $('.modal').modal('close');

            $('.cv-creator .cv-creator__modal #modal_step').val('3');

        });

        /** DOWNLOAD CV FROM MODAL */
        $('.cv-creator__modal .step_3 .download-cv').on('click', function() {
            var pdf_id = $('#pdf_id').val();
            
            // URL of the PDF file
            const pdfUrl = template_directory + '/cvs/' + pdf_id + '.pdf';
            
            $('<a>', {
                href: pdfUrl,
                target: '_blank',
                download: pdf_id + '.pdf',
            }).appendTo('body')[0].click();

            $('.modal').modal('close');

            $('.cv-creator .cv-creator__modal #modal_step').val('1');
        });

        // Validate CV Fields
        $(".cv-creator .cv-creator__modal .step_4 #form-agency-step4").validate({
            rules: {
                hear_about_us: {
                    required: true
                },
                candidate_availability: {
                    required: true
                },
                birthdate: {
                    required: true
                },
                nationality: {
                    required: true
                },
                linkedin_url: {
                    required: true
                },
                password: {
                    required: true
                },
                confirm_password: {
                    required: true,
                    equalTo: "#password"
                },
                n_1_year_of_experience: {
                    required: true
                }
            },
            errorPlacement: function (error, element) { }
        });

        // Step 4 CTA
        $('.cv-creator .cv-creator__modal .step_4 .cta-agency button').on('click', function(e) {
            e.preventDefault();
            $('.global-overlay-loader').fadeIn(100);
            var $linkedinField = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #linkedin_url');
            if ($linkedinField.length) {
                $linkedinField.val(cvcreatorNormalizeUrlValue($linkedinField.val()));
            }

            if ($('.cv-creator .cv-creator__modal .step_4 #form-agency-step4').valid()) {
                const input = document.querySelector(".cv-creator__form .form form #mobile");
                const iti = intlTelInput.getInstance(input);
                var country_data = iti.getSelectedCountryData();
                
                //Read Data
                var param = {
                    "site": "talento",
                    "msg": "resumeCreateCandidateMW",
                };
                var fields = {};
                fields['pdf_id'] = $('.cv-creator__form .form form #pdf_id').val();
                fields['birthdate'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #birthdate').val();
                fields['nationality'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #nationality').val();
                fields['linkedin_url'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #linkedin_url').val();
                fields['candidate_availability'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #candidate_availability').val();
                fields['hear_about_us'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #hear_about_us').val();
                fields['password'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #password').val();
                fields['lead_source_form'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #lead_source_form').val();
                fields['lead_source_channel'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #lead_source_channel').val();
                fields['lead_magnet_download'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #lead_magnet_download').val();
                param['fields'] = fields;

                //Change Button CTA
                $('.cv-creator .cv-creator__modal .step_4 .cta-agency button').prop('disabled', true);
                $('.cv-creator .cv-creator__modal .step_4 .cta-agency button').html('Procesando...');

                //Request API
                $.post(base_url + '/api', { param: JSON.stringify(param) }).done(function (data) {
                    //Check Result
                    if (data.status == 1) {
                        // Assign Candidate ID
                        $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 #candidate_id').val(data.data.id);
                        candidate_id = data.data.id;

                        //Google Analytics Event
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'createAccount'
                        });

                        //Fade In & Fade Out
                        $('.cv-creator .cv-creator__modal .step_4').fadeOut(0);

                        $('.cv-creator .cv-creator__modal .step_5').fadeIn('slow');

                        sendPIN(candidate_id);

                        // DEO-366: cooldown reducido de 5 a 2 minutos (match server-side enforcement)
                        $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .timer').html('Reenviar en <span class="minutes">02</span>:<span class="seconds">00</span>');

                        var deadline = new Date(Date.parse(new Date()) + 2 * 60 * 1000);
                        initializeClock('form-agency-step5', deadline);
                        $('.global-overlay-loader').fadeOut(200);
                    } else {
                        //Show Error
                        M.toast({ html: data.msg });
                        $('.global-overlay-loader').fadeOut(200);
                    }

                    //Change Button CTA
                    $('.cv-creator .cv-creator__modal .step_4 .cta-agency button').prop('disabled', false);
                    $('.cv-creator .cv-creator__modal .step_4 .cta-agency button').html('Guardar');

                });

            }

            return false;
        });

        const formPIN = document.querySelector('#form-agency-step5');
        formPIN.addEventListener('keypress', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 #btnValidatePin').trigger( "click" );
            }
        });

        // Validate CV Fields
        $(".cv-creator .cv-creator__modal .step_5 #form-agency-step5").validate({
            rules: {
                pin: {
                    required: true
                }
            },
            errorPlacement: function (error, element) { }
        });

        // CV Creator Validate PIN
        $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 #btnValidatePin').on('click', function (e) {
            e.preventDefault();

            $('.global-overlay-loader').fadeIn(100);
            if ($('.cv-creator .cv-creator__modal .step_5 #form-agency-step5').valid()) {

                var candidate_id = $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 #candidate_id').val();
                var pin = $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 #pin').val();
                var param = '{"site":"talento", "msg":"talentValidatePin","fields":{"candidate_id":"' + candidate_id + '","pin":"' + pin + '"}}';

                $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .cta-agency #btnValidatePin').prop('disabled', true);
                $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .cta-agency #btnValidatePin').html('Procesando...');

                $.post(base_url + '/api', { param: param }).done(function (data) {
                    if (data.status == 0)
                    {
                        $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 #pin').val('');

                        //$('.register-talento #register_step3').fadeOut(0);
                        //$('.register-talento #register_step3').fadeIn('slow');

                        $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .cta-agency #btnValidatePin').prop('disabled', false);
                        $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .cta-agency #btnValidatePin').html('Validar');
                        $('.global-overlay-loader').fadeOut(200);
                    }
                    else if (data.status == 1)
                    {
                        // Last Step - Newsletter: RETIRED (DEO-589). The newsletter subscription no longer exists in
                        // RecruitCRM (nor in the portal's Ajustes page) and the handler is commented out in api_cvcreator.php.
                        /*
                        var param = {
                            "site": "talento",
                            "msg": "candidateNewsletterMW",
                        };
                        var fields = {};
                        fields['first_name'] = $('.cv-creator__form .form form #first_name').val();
                        fields['last_name'] = $('.cv-creator__form .form form #last_name').val();
                        fields['second_last_name'] = $('.cv-creator__form .form form #second_last_name').val();
                        fields['job_title'] = $('.cv-creator__form .form form #current_job_title').val();
                        fields['job_title_experience'] = $('.cv-creator__form .form form #years_of_experience').val();
                        fields['skill_name_1'] = $('.cv-creator__form .form form #primary_skill').val();
                        fields['skill_experience_1'] = $('.cv-creator__form .form form #n_1_year_of_experience').val();
                        fields['email'] = $('.cv-creator__form .form form #email').val();
                        fields['source'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #lead_source_form').val();
                        fields['utm_source'] = $('.cv-creator .cv-creator__modal .step_4 #form-agency-step4 #lead_source_channel').val();
                        param['fields'] = fields;

                        //Request API
                        $.post(base_url + '/api', { param: JSON.stringify(param) }).done(function (data) {
                            //Check Result
                            if (data.status == 1) {
                                //Show Success
                                //M.toast({ html: 'Newsletter enviado' });
                            }
                            else {
                                //Show Error
                                //M.toast({ html: data.msg });
                            }
                        });
                        */

                        // DEO-296: Auto-login after successful PIN validation
                        // Create SSO session cookie before redirect to confirmation page
                        var userEmail = $('#email').val();
                        var userPassword = $('#password').val();

                        if (userEmail && userPassword) {
                            var loginParam = {
                                "site": "talento",
                                "msg": "ssoAutoLogin",
                                "fields": {
                                    "email": userEmail,
                                    "password": userPassword
                                }
                            };

                            $.post(base_url + '/api', { param: JSON.stringify(loginParam) }).done(function (loginData) {
                                if (loginData.status == 1 && loginData.session_token) {
                                    // Create SSO cookie
                                    var cookieDomain = loginData.cookie_domain || '.coderslink.com';
                                    var sessionDuration = loginData.session_duration || 86400;
                                    var isSecure = window.location.protocol === 'https:' ? '; secure' : '';

                                    document.cookie = 'coderslink_session=' + loginData.session_token +
                                        '; domain=' + cookieDomain +
                                        '; path=/' + isSecure + '; samesite=lax; max-age=' + sessionDuration;
                                }
                                window.location.href = base_url + '/crear-cv/confirmacion/';
                            }).fail(function () {
                                window.location.href = base_url + '/crear-cv/confirmacion/';
                            });
                        } else {
                            window.location.href = base_url + '/crear-cv/confirmacion/';
                        }

                    }
                    else if (data.status == 2)
                    {
                        $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 #pin').val('');

                        //$('.register-talento #register_step3').fadeOut(0);
                        //$('.register-talento #register_step3').fadeIn('slow');

                        $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .cta-agency #btnValidatePin').prop('disabled', false);
                        $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .cta-agency #btnValidatePin').html('Validar');
                        $('.global-overlay-loader').fadeOut(200);
                    }

                    M.toast({ html: data.msg });
                    $('.global-overlay-loader').fadeOut(200);
                });
            }
            return false;
        });

        //Request New Code (Dynamic)
        var pinStep5 = cvcreatorCreatePinStep5Module(
            {
                cvcreatorGetTimeRemaining: cvcreatorGetTimeRemaining,
                cvcreatorParseRetryAfter: cvcreatorParseRetryAfter,
                cvcreatorFormatPinCountdown: cvcreatorFormatPinCountdown,
                cvcreatorShouldShowRequestNewPin: cvcreatorShouldShowRequestNewPin,
                cvcreatorCreatePinClockController: cvcreatorCreatePinClockController
            },
            {
                clearInterval: clearInterval,
                setInterval: setInterval,
                document: document,
                setTimerHtml: function (html) {
                    $('.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .timer').html(html);
                }
            }
        );

        function initializeClock(id, endtime) {
            pinStep5.initializeClock(id, endtime);
        }

        pinStep5.bindRequestNewPinClick({
            $: $,
            clickSelector: '.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .requestNewPIN',
            candidateIdSelector: '.cv-creator .cv-creator__modal .step_5 #form-agency-step5 #candidate_id',
            timerSelector: '.cv-creator .cv-creator__modal .step_5 #form-agency-step5 .timer',
            apiUrl: base_url + '/api',
            clockId: 'form-agency-step5',
            showToast: function (msg) { M.toast({ html: msg }); },
            initializeClock: initializeClock
        });

        function sendPIN(candidate_id) {
            var param = pinStep5.buildSendConfirmationPinParam(candidate_id);
    
            $.post(base_url + '/api', { param: param }).done(function (data) {
                //Check Result
                if (data.status == 1) {
                    return 1;
                }
                else {
                    //Show Error
                    M.toast({ html: data.msg });
                    return 0;
                }
            });
        }  
    }

});